import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlarm = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 1489",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Group 1488",
			children: [/* @__PURE__ */ _jsxs("g", {
				id: "Group 1252",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M18.8799 6.66006L20.7099 4.83006C21.0999 4.44006 21.0999 3.80006 20.7099 3.41006L18.5899 1.29006C18.1999 0.900059 17.5599 0.900059 17.1699 1.29006L15.3399 3.12006C16.8299 3.94006 18.0599 5.17006 18.8799 6.66006Z",
					stroke: "currentColor",
					strokeWidth: 1.2,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}), /* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M6.65988 3.12006L4.82988 1.29006C4.43988 0.900059 3.79988 0.900059 3.40988 1.29006L1.28988 3.41006C0.899875 3.80006 0.899875 4.44006 1.28988 4.83006L3.11988 6.66006C3.93988 5.17006 5.16988 3.94006 6.65988 3.12006Z",
					stroke: "currentColor",
					strokeWidth: 1.2,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})]
			}), /* @__PURE__ */ _jsxs("g", {
				id: "Group 1251",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Vector_3",
					d: "M10.9999 5V11H15.9999",
					stroke: "currentColor",
					strokeWidth: 1.2,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}), /* @__PURE__ */ _jsx("path", {
					id: "Vector_4",
					d: "M10.9999 11.5C11.276 11.5 11.4999 11.2761 11.4999 11C11.4999 10.7239 11.276 10.5 10.9999 10.5C10.7237 10.5 10.4999 10.7239 10.4999 11C10.4999 11.2761 10.7237 11.5 10.9999 11.5Z",
					stroke: "currentColor",
					strokeWidth: 1.2,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})]
			})]
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group 1480",
			children: [/* @__PURE__ */ _jsxs("g", {
				id: "Group 1479",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Vector_5",
					d: "M4.78988 17.5L2.14988 20.15C1.94988 20.34 1.94988 20.66 2.14988 20.85C2.33988 21.05 2.65988 21.05 2.84988 20.85L5.54988 18.16C5.27988 17.95 5.02988 17.74 4.78988 17.5Z",
					stroke: "currentColor",
					strokeWidth: 1.2,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}), /* @__PURE__ */ _jsx("path", {
					id: "Vector_6",
					d: "M19.8499 20.15L17.2099 17.5C16.9699 17.74 16.7199 17.95 16.4499 18.16L19.1499 20.85C19.2399 20.95 19.3699 21 19.4999 21C19.6299 21 19.7599 20.95 19.8499 20.85C20.0499 20.66 20.0499 20.34 19.8499 20.15Z",
					stroke: "currentColor",
					strokeWidth: 1.2,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})]
			}), /* @__PURE__ */ _jsx("path", {
				id: "Vector_7",
				d: "M10.9999 20C15.9704 20 19.9999 15.9706 19.9999 11C19.9999 6.02944 15.9704 2 10.9999 2C6.02931 2 1.99988 6.02944 1.99988 11C1.99988 15.9706 6.02931 20 10.9999 20Z",
				stroke: "currentColor",
				strokeWidth: 1.2,
				strokeMiterlimit: 10,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		})]
	})
});
export default SvgAlarm;
